import React from "react";
import NavigationItems from "./items";
import { useOktaAuth } from "@okta/okta-react";

const NavigationBigScreen: React.FC = () => {
  const { oktaAuth } = useOktaAuth();

  const logOut = React.useCallback(async () => {
    oktaAuth.signOut({ clearTokensBeforeRedirect: true, revokeAccessToken: true, revokeRefreshToken: true, postLogoutRedirectUri: window.location.origin });
  }, [oktaAuth]);

  return (
    <>
      <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
        <div className="flex flex-col flex-grow pt-5 bg-zenlist-500 overflow-y-auto">
          <div className="flex items-center flex-shrink-0 px-4">
            <img className="h-8 w-auto" src="/logo.svg" alt="Zenlist" />
            <h1 className="text-1xl font-semibold text-white pl-2">
              Zenlist Admin
            </h1>
          </div>
          <div className="mt-5 flex-1 flex flex-col">
            <nav className="flex-1 px-2 pb-4 space-y-1">
              <NavigationItems />
            </nav>
          </div>
          <div className="flex-shrink-0 flex border-t border-zenlist-300 p-4">
            <div className="flex-shrink-0 w-full group block">
              <div className="flex items-center">
                <div className="ml-3">
                  <p
                    onClick={logOut}
                    className="text-sm font-medium text-indigo-200 group-hover:text-white"
                  >
                    Log Out
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavigationBigScreen;
